import { render, staticRenderFns } from "./BuildIndividualAccountsFromList.vue?vue&type=template&id=64626d7a&scoped=true"
import script from "./BuildIndividualAccountsFromList.vue?vue&type=script&lang=js"
export * from "./BuildIndividualAccountsFromList.vue?vue&type=script&lang=js"
import style0 from "./BuildIndividualAccountsFromList.vue?vue&type=style&index=0&id=64626d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64626d7a",
  null
  
)

export default component.exports